import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JottoNotificationService } from '@portals/api';
import { switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '@portals/environments';
import { ReportsState } from '@portals/store';
import { BaseComponent } from '@portals/core';
import { AuthState } from '@portals/store';

@Component({
	selector: 'portals-dashboard-filter',
	templateUrl: './dashboard-filter.component.html',
	styleUrls: ['./dashboard-filter.component.scss'],
})
export class DashboardFilterComponent extends BaseComponent implements OnInit {
	filterForm: FormGroup;
	channels: any[] = [];
	projects: any[] = [];
	notifications: any[] = [];
	countries: any[] = [];
	loading = false;
    roleType: string;
    app = environment.app;

	constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<DashboardFilterComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private notificationService: JottoNotificationService, protected authState: AuthState, private reportState: ReportsState) {
        super();
        this.roleType = authState.data.role.type;
        this.filterForm = this.fb.group({
			channelIds: [[]],
			projectIds: [[]],
			notificationIds: [[]],
			countryIds: [[]],
			startDate: [null],
			endDate: [null],
			isSudo: this.roleType === 'super_admin',
		});
	}

	ngOnInit() {
        this.projects = this.data.projects;
		if (this.data.currentFilters) {
			this.filterForm.patchValue(this.data.currentFilters);
		}
		if (this.app === 'Jotto') {
			this.channels = this.data.channels;
			this.notifications = this.data.notifications;
			// Subscribe to changes in channelIds
			this.filterForm
				.get('channelIds')
				?.valueChanges.pipe(
					switchMap((channelIds) => {
						this.loading = true;
						if (channelIds.length === 0) {
							// Clear notifications when no channels are selected
							this.notifications = [];
							this.filterForm.get('notificationIds')?.setValue([]);
							return of(null);
						} else {
							return this.notificationService.getNotificationsByChannels(channelIds);
						}
					})
				)
				.subscribe(
					(notifications) => {
						if (notifications) {
							this.notifications = notifications;
							// Clear previously selected notifications that are no longer available
							const currentNotificationIds = this.filterForm.get('notificationIds')?.value;
							const availableNotificationIds = this.notifications.map((n) => n.id);
							const validNotificationIds = currentNotificationIds.filter((id: any) => availableNotificationIds.includes(id));
							this.filterForm.get('notificationIds')?.setValue(validNotificationIds);
						}
						this.loading = false;
					},
					(error) => {
						console.error('Error fetching notifications:', error);
						this.loading = false;
						// Provide user feedback about the error
						// You might want to use a snackbar or alert service here
					}
				);
		} else if (this.app === 'Tobacco Atlas') {
			this.subscribe(
				this.reportState.getCountryForFilter().pipe(
					tap((data: any) => {
						this.countries = data;
					})
				)
			);
		} else {
			//pass
		}
	}

	onCancel(): void {
		this.dialogRef.close();
	}

    onApply(): void {
        const formValue = this.filterForm.value;

        // Set default endDate to the current date if not provided
        if (!formValue.endDate) {
            formValue.endDate = new Date();
        }

        // Set startDate to one month before the endDate if not provided
        if (!formValue.startDate) {
            formValue.startDate = new Date(new Date(formValue.endDate).setMonth(new Date(formValue.endDate).getMonth() - 1));
        }

        // Close the dialog and pass the modified formValue
        this.dialogRef.close({ formData: formValue, notifications: this.notifications });
    }
}
